import { makeHead } from '@/root/components/shared/DayPicker/CustomWeekBar'

export const Head = makeHead('text-base-medium-light text-sm font-bold tracking-[0.06em]')
